import { Routes } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';

import { AdminGuard } from './guards/admin.guard';
import { CanDeactivateGuard } from './guards/canDeactivate.guard';
import { DetailPageGuard } from './guards/detailPage.guard';
import { SessionGuard } from './guards/session.guard';
import { UserAccessGuard } from './guards/user-access.guard';

export enum RouteUserRole {
  ADMIN = 'Admin',
  DEFAULT = 'Nurse'
}

export const routes: Routes = [
  {
    path: 'home',
    loadComponent: () => import('./pages/home/home.component').then((m) => m.HomeComponent),
    canActivate: [SessionGuard, MsalGuard, UserAccessGuard],
    canDeactivate: [CanDeactivateGuard],
    data: {
      showInNavigation: true,
      routerLink: '/home',
      icon: 'view-column',
      labelKey: 'TherapyJobsDashboard',
      userRole: RouteUserRole.DEFAULT
    }
  },
  {
    path: 'detail',
    loadComponent: () =>
      import('./components/detail-page/detail-page-view/detail-page-view.component').then(
        (m) => m.DetailPageViewComponent
      ),
    canActivate: [SessionGuard, MsalGuard, DetailPageGuard, UserAccessGuard],
    canDeactivate: [CanDeactivateGuard],
    data: {
      userRole: RouteUserRole.DEFAULT
    }
  },
  {
    path: 'create',
    loadComponent: () =>
      import('./components/detail-page/detail-page-new/detail-page-new.component').then(
        (m) => m.DetailPageNewComponent
      ),
    canActivate: [SessionGuard, MsalGuard, UserAccessGuard],
    canDeactivate: [CanDeactivateGuard],
    data: {
      userRole: RouteUserRole.DEFAULT
    }
  },
  {
    path: 'configuration',
    loadComponent: () => import('./pages/configuration/configuration.component').then((m) => m.ConfigurationComponent),
    canActivate: [SessionGuard, MsalGuard, AdminGuard],
    canDeactivate: [CanDeactivateGuard],
    data: {
      showInNavigation: true,
      routerLink: '/configuration',
      icon: 'settings',
      labelKey: 'PageTitleConfiguration',
      userRole: RouteUserRole.ADMIN
    }
  },
  {
    path: 'organization-settings',
    loadComponent: () =>
      import('./components/organization-settings/organization-settings.component').then(
        (m) => m.OrganizationSettingsComponent
      ),
    canActivate: [SessionGuard, MsalGuard, AdminGuard],
    data: {
      showInNavigation: false,
      routerLink: '/organization-settings',
      icon: 'settings',
      labelKey: 'PageTitleOrganizationSettings',
      userRole: RouteUserRole.ADMIN
    }
  },
  {
    path: 'history',
    loadComponent: () => import('./pages/history/history-page.component').then((m) => m.HistoryPageComponent),
    canActivate: [SessionGuard, MsalGuard, UserAccessGuard],
    data: {
      showInNavigation: true,
      routerLink: '/history',
      icon: 'history',
      labelKey: 'PageTitleHistory',
      disabled: false,
      userRole: RouteUserRole.DEFAULT
    }
  },
  {
    path: 'about',
    loadComponent: () => import('./pages/about/about-page.component').then((m) => m.AboutPageComponent),
    canActivate: [SessionGuard, MsalGuard],
    data: {
      showInNavigation: true,
      routerLink: '/about',
      icon: 'info',
      labelKey: 'PageTitleAbout',
      disabled: false
    }
  },
  {
    path: 'unavailable',
    loadComponent: () => import('./components/unavailable/unavailable.component').then((m) => m.UnavailableComponent),
    data: {
      showInNavigation: false
    },
    canActivate: [MsalGuard]
  },
  { path: '', redirectTo: '/home', pathMatch: 'full' },
  { path: '**', redirectTo: '/home', pathMatch: 'full' }
];
